import styled from 'styled-components';
export const StyledLandmark = styled.div `
  display: contents;
`;
//# sourceMappingURL=BKJLandmark.styled.js.map